import { Injectable, ErrorHandler, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CONFIG } from '../constants/constants';
import { SesionService } from '../services/sesion.service';
import { UtilService } from '../services/util.service';

@Injectable()
export class GlobalErrorService implements ErrorHandler {
    constructor(
        private zone: NgZone,
        private _util: UtilService,
        private sesionService: SesionService,
        private router: Router
    ) {}

    handleError(e: any) {
        if (e.status == 0) {
            Swal.fire(
                'Error inesperado',
                'Sistema fuera de servicio, por favor intente más tarde',
                'error'
            );
        } else if (e.status == 204) {
            Swal.fire(
                'Error inesperado',
                'Por favor intente más tarde',
                'error'
            );
        } else if (e.status == 401) {
            //Usuario y contraseña incorrectos
            if (e.url.includes('login')) {
                Swal.fire(
                    'Usuario y contraseña incorrectos',
                    'Por favor valide y vuelva a intentar',
                    'warning'
                );
            } else {
                Swal.fire(
                    'Permiso denegado',
                    'Por valide la sesión de usuario',
                    'warning'
                );
            }
        } else if (e.status == 403) {
            if (this.sesionService.isAuthenticated()) {
                this.sesionService.logOut();
            }
            this.router.navigate(CONFIG.LOGIN_PAGE);
            Swal.fire(e.error.message, e.message, 'error');
        } else if (e.status == 404) {
            //-------------------------------------NOT_FOUND
        } else if (e.status == 500) {
            Swal.fire(
                'Se ha presentado un error',
                'Por favor intente más tarde',
                'error'
            );
            console.log(e);
        } else {
            Swal.fire(
                'Se ha presentado un error',
                'Por favor intente más tarde ó comuniquese con el administrador',
                'error'
            );
            console.log(e);
        }
    }
}
